import { render } from "./Topbar.vue?vue&type=template&id=5461dc0e"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"
script.render = render

export default script